import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Pagination = ({ itemsCount, pageSize, currentPage, onPageChange }) => {
   const pagesCount = Math.ceil(itemsCount / pageSize);

   if (pagesCount === 1) return null;
   const pages = _.range(1, pagesCount + 1);

   return (
      <nav className='pagination is-right is-rounded' role='navigation' aria-label='pagination'>
         <ul className='pagination-list'>
            {pages.map((page) => (
               <li key={page}>
                  <button
                     className={`button is-small pagination-link ${
                        page === currentPage ? 'is-current' : ''
                     }`}
                     onClick={() => onPageChange(page)}
                  >
                     {page}
                  </button>
               </li>
            ))}
         </ul>
         <button className='button is-small pagination-previous'>Previous</button>
         <button className='button is-small pagination-next'>Next page</button>
      </nav>
   );
};

Pagination.propTypes = {
   itemsCount: PropTypes.number.isRequired,
   pageSize: PropTypes.number.isRequired,
   currentPage: PropTypes.number.isRequired,
   onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
